import { HelloUser } from '../../organization/components/HelloUser';
import { TaxReturnRecentCard } from '../../tax-returns/components/TaxReturnRecentCard';
import { TaxpayerRecentCard } from '../../taxpayers/components/TaxpayerRecentCard';

export const HomePage = () => {
  return (
    <div>
      <div className="mb-5">
        <HelloUser />
      </div>
      <div className="row">
        <div className="col-12 col-md-6">
          <TaxpayerRecentCard />
        </div>
        <div className="col-12 col-md-6">
          <TaxReturnRecentCard />
        </div>
      </div>
    </div>
  );
};
